import { postActivityLog } from 'services/generalServices';

export function useActivityLog() {
  const addActivity = (data) => {
    postActivityLog(data).catch((error) => console.error(error));
  };

  return { addActivity };
}
